import { render } from "./inquiryInfo.vue?vue&type=template&id=70278cf9&scoped=true&ts=true"
import script from "./inquiryInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./inquiryInfo.vue?vue&type=script&setup=true&lang=ts"

import "./inquiryInfo.vue?vue&type=style&index=0&id=70278cf9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70278cf9"],['__file',"src/components/scan/inquiryinfo/inquiryInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70278cf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70278cf9', __exports__)) {
    console.log('reload')
    api.reload('70278cf9', __exports__)
  }
  
  module.hot.accept("./inquiryInfo.vue?vue&type=template&id=70278cf9&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('70278cf9', render)
  })

}


export default __exports__